import intlTelInput, { COUNTRY_SELECTOR_MODE, VALIDATION_ERROR } from "intl-tel-input";
import { de, en, es, fr, ja, nl, no, sv, zh } from "intl-tel-input/locale";
import { FormAssociatedCustomElementsMixin } from "./mixins/form-associated-custom-elements";

function uiTranslations() {
  switch(document.querySelector(`html`)?.lang) {
    case 'zh-TW':
      return zh
    case 'nl':
      return nl;
    case 'fr':
      return fr;
    case 'de':
      return de;
    case 'ja':
      return ja;
    case 'no':
      return no;
    case 'es':
      return es;
    case 'sv':
      return sv;
    default:
      return en;
  }
}

class PhoneInputElement extends FormAssociatedCustomElementsMixin(HTMLElement) {
  constructor() {
    super();
  }

  async connectedCallback() {
    if(!this.isConnected){ return }

    this.telephoneInput = intlTelInput(this.input, {
      initialCountry: this.dataset.clientCountryCode,
      numberDisplayFormat: "NATIONAL",
      separateDialCode: false,
      countrySelectorMode: "AUTO",
      countryOrder: ["us"],
      uiTranslations: uiTranslations(),
      classNames: {
        countryList: "wa-list-plain"
      },
      countrySelectorMode: COUNTRY_SELECTOR_MODE.DROPDOWN ,
      loadUtils: () => import("intl-tel-input/utils"),
    })

    await this.telephoneInput.promise
    this.syncValue()

    this._boundChangeHandler = this.changeHandler.bind(this)
    this.input.addEventListener(`change`, this._boundChangeHandler)
    this.addEventListener(`countrychange`, this._boundChangeHandler)
  }

  changeHandler(event){
    this.syncValue()
  }

  syncValue() {
    if(this.formattedNumber.toString().trim() == "" && this.required) {
      this._internals.setFormValue("")
      this._internals.setValidity({valueMissing: true}, this.requiredError)
      return
    }

    if(this.formattedNumber.toString().trim() == "" && !this.required) {
      this.value = ""
      return
    }

    if(this.telephoneInput.isValidNumber()) {
      this.value = this.telephoneInput.getNumber()
    } else {
      this._reflectTelephoneValidationError()
    }
  }

  _updateFormValue(newValue) {
    super._updateFormValue(newValue);
    const event = new InputEvent(`change`, { bubbles: true });

    this.dispatchEvent(event);
  }

  get input() {
    return this.querySelector(`:scope [data-tel-input-target]`)
  }

  get formattedNumber() {
    return this.telephoneInput.getNumber()
  }

  _reflectTelephoneValidationError() {
    const errorCode = this.telephoneInput.getValidationError()
    let errorMessage;
    switch(errorCode) {
    case VALIDATION_ERROR.INVALID_COUNTRY_CODE:
      errorMessage = this.invalidCountryCodeError
      break
    case VALIDATION_ERROR.IS_POSSIBLE:
      errorMessage = this.isPossibleError
      break
    case VALIDATION_ERROR.IS_POSSIBLE_LOCAL_ONLY:
      errorMessage = this.isPossibleLocalOnlyError
      break
    case VALIDATION_ERROR.TOO_LONG:
      errorMessage = this.tooLongError
      break
    case VALIDATION_ERROR.TOO_SHORT:
      errorMessage = this.tooShortError
      break
    default:
      errorMessage = this.invalidLengthError
    }

    this._internals.setFormValue("")
    this._internals.setValidity({ customError: true }, errorMessage);
  }

  get invalidCountryCodeError() {
    return this.getAttribute(`invalid-country-code-error`);
  }

  get tooLongError() {
    return this.getAttribute(`too-long-error`);
  }

  get tooShortError() {
    return this.getAttribute(`too-short-error`);
  }

  get invalidLengthError() {
    return this.getAttribute(`invalid-length-error`);
  }

  get requiredError() {
    return this.getAttribute(`required-error`);
  }

  get isPossibleLocalOnlyError() {
    return this.getAttribute(`is-possible-local-only-error`);
  }

  get isPossibleError() {
    return this.getAttribute(`is-possible-error`);
  }
}

if (!window.customElements.get('phone-input')) {
  window.customElements.define('phone-input', PhoneInputElement);
}
